<template>
    <div class="row mt-3">
        <div v-for="index in 12" :key="index" class="col-12 col-sm-6 col-lg-4 col-xl-3 mb-4">
            <div class="card h-100">
                <div class="image"></div>
                <div class="title"></div>
                <div class="title"></div>
                <div class="title"></div>
                <div class="informations"></div>
                <div class="button"></div>
            </div>
        </div>
    </div>
</template>
<style scoped>
.card {
    background: #e7e7e7;
    border-color: #e7e7e7;
    min-height: 400px;
}

.dark .card {
    background: #333945;
    border-color: #333945;
}

.image {
    background-color: #dedede;
    height: 185px;
    margin-bottom: 15px;
    border-radius: 8px 8px 0px 0px;
}

.dark .image {
    background-color: #3e4553;
}

.title {
    background-color: #dedede;
    height: 12px;
    margin-top: 10px;
    margin-left: 20px;
    margin-right: 20px;
}

.dark .title {
    background-color: #3e4553;
}

.informations {
    background-color: #dedede;
    height: 12px;
    margin-top: 35px;
    margin-left: 20px;
    margin-right: 20px;
}

.dark .informations {
    background-color: #3e4553;
}

.button {
    background-color: #dedede;
    height: 45px;
    margin-top: 20px;
    margin-left: 20px;
    margin-right: 20px;
}

.dark .button {
    background-color: #3e4553;
}
</style>